import { useMemo } from "react";
import { useCompany } from "./useCompany";
import { useSubscription } from "./useSubscription";

export function useTrialStatus() {
  const { company, loading: companyLoading } = useCompany();
  const { isSubscribed, loading: subLoading } = useSubscription();

  const trialStatus = useMemo(() => {
    if (companyLoading || subLoading) {
      return { isTrialExpired: false, loading: true, hasCompany: false };
    }

    // No company yet — not expired, let them create one
    if (!company) {
      return { isTrialExpired: false, loading: false, hasCompany: false };
    }

    // Has active subscription — never blocked
    if (isSubscribed) {
      return { isTrialExpired: false, loading: false, hasCompany: true };
    }

    // Check trial expiration
    const now = new Date();
    
    if (!company.trial_ends_at) {
      // No trial_ends_at set — fallback: calculate from created_at + 14 days
      if (company.created_at) {
        const fallbackEnd = new Date(company.created_at);
        fallbackEnd.setDate(fallbackEnd.getDate() + 14);
        const expired = now >= fallbackEnd;
        return { isTrialExpired: expired, loading: false, hasCompany: true };
      }
      // No created_at either — treat as expired
      return { isTrialExpired: true, loading: false, hasCompany: true };
    }

    const trialEnd = new Date(company.trial_ends_at);
    const expired = now >= trialEnd;

    return { isTrialExpired: expired, loading: false, hasCompany: true };
  }, [company, companyLoading, isSubscribed, subLoading]);

  return trialStatus;
}
